module.exports = __webpack_public_path__ + "frontend/images/devise-singin-xs-304d42b6cb57a71b53b8e8f130164361.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/devise-singin-xs.jpg
// module id = 336
// module chunks = 2